export class OccupationInformation {
  uid?: any;
  version?:number;
  category?: string;
  companyType?: string;
  companyName?: string;
  companyAddress?: string;
  companyLandmark?: string;
  distanceFromBranch?: number;
  designation?: string;
  totalExperience?: number;
  currentCompanyExperience?: number;
  grossMonthlyIncome?: number;
  netMonthlyIncome?: number;
  salaryCreditMode?: string;
  epfoNumber?: string;
  linkToId?: string;
  linkToUid?: number;
  linkToType?: string;
  contextUid?: number;
  contextId?: number;
  contextType?: string;
}
